/* 2026-07-23, Joel: "ok do that". Companion-part picker under Add to Cart on saber tube and light
   painting tube PDPs (see snippets/aoam-addons.liquid). Delete this file to roll back.

   How it hooks in: theme.AjaxProduct binds a 'submit' listener directly on the product form and posts
   a single form-encoded item to /cart/add. We listen on `document` in the CAPTURE phase, which always
   runs before an at-target listener on the form, so we get first refusal on the submit. If any add-on
   is ticked we stop the event, POST the ticked products to /cart/add.js as their own line items, then
   re-dispatch the submit so the theme adds the main product and shows its usual cart popup last.

   The re-dispatched submit is marked with data-aoam-addons-done so we do not loop. */

(function () {
  'use strict';

  // A template can render the product form more than once (main PDP + quick-view modal), which would
  // include this script twice and bind the listener twice, double-adding every ticked part.
  if (window.__aoamAddonsBound) return;
  window.__aoamAddonsBound = true;

  var DONE_ATTR = 'data-aoam-addons-done';
  var GATE_ATTR = 'data-aoam-gate-done';

  // 2026-10-06 (Claude, from the 2026-10-05 cart audit): ticking or unticking a box in code fires no 'change', so the
  // add-on cards, the box total and the Add to Cart running total (assets/aoam-atc-price.js) kept showing parts that
  // were no longer ticked after an add (BitWhip Kit button stuck on $189.90). Tell them exactly as a shopper's own
  // tap would. Roll back: empty this function.
  function announce(boxes) {
    for (var i = 0; i < boxes.length; i++) {
      try { boxes[i].dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
    }
  }

  /* ---------------------------------------------------------------------------------------------
     Compatibility gate. 2026-07-29, Joel: customers can buy a bare tube without realising it needs
     an adapter to mount and a Critter to light it. This intercepts Add to Cart, but ONLY interrupts
     when the resulting cart genuinely would not work. If the required parts are already ticked, or
     already sitting in the cart, it stays out of the way completely. Config comes from the
     [data-aoam-gate] JSON block in snippets/aoam-addons.liquid.
     --------------------------------------------------------------------------------------------- */

  function gateConfig(form) {
    var node = form.querySelector('[data-aoam-gate]') || document.querySelector('[data-aoam-gate]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error('[aoam-addons] gate config is not valid JSON', error);
      return null;
    }
  }

  function cartState() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        return response.ok ? response.json() : { items: [] };
      })
      .catch(function () {
        // A failed cart read must never block a sale. Treat it as "cannot tell" and let the buy through.
        return null;
      });
  }

  function hasLightSource(items, config) {
    for (var i = 0; i < items.length; i++) {
      var type = items[i].product_type || '';
      if (config.light_types.indexOf(type) !== -1) return true;
      // Anything sold as a kit or package ships a Critter inside a single line item, so the flashlight
      // is invisible to us. Be permissive: a missed warning is far cheaper than a false one.
      if (/kit|package|bundle/i.test(type) || /kit|package|bundle/i.test(items[i].handle || '')) return true;
    }
    return false;
  }

  function hasAdapter(items, config) {
    for (var i = 0; i < items.length; i++) {
      if (config.adapter_handles.indexOf(items[i].handle) !== -1 || (config.adapter_kits || []).indexOf(items[i].handle) !== -1) return true; /* 2026-10-10 audit: kits ship the long adapter */
    }
    return false;
  }

  /* 2026-08-12, Joel: "the pop up that shows when a customer adds a saber tube or light painting tube
     to the cart does not properly show the rgb critter tube adapter part it only shows the rgb critter
     bt as the add on option". The adapter row is pre-ticked on the PDP, so it was never counted as
     missing and never reached the dialog: a shopper being told their tube will not light up saw one
     row for the flashlight and no mention of the adapter that same tube needs.

     Every part the tube needs and the cart does not already hold is now LISTED. What decides whether
     the dialog opens at all is unchanged - only a part that would genuinely be absent from the
     resulting cart is `blocking`, so a shopper with the adapter ticked and a Critter already in the
     cart still buys without ever seeing this. Roll back by restoring the `!ticked && !owned` push and
     the `missing.length` test in runGate. */
  function neededParts(form, cart, config) {
    var needed = [];
    var items = (cart && cart.items) || [];

    var requiredRow = form.querySelector('[data-aoam-addon-required]');
    if (requiredRow) {
      var checkbox = requiredRow.querySelector('[data-aoam-addon]');
      var handle = requiredRow.getAttribute('data-addon-handle');
      var ticked = !!(checkbox && checkbox.checked);
      var owned = config.adapter_handles.indexOf(handle) !== -1 ? hasAdapter(items, config) : false;

      if (!owned) {
        needed.push({
          kind: 'addon',
          row: requiredRow,
          blocking: !ticked,
          title: requiredRow.getAttribute('data-addon-title') || 'Required part',
          price: requiredRow.getAttribute('data-addon-price') || '',
          image: requiredRow.getAttribute('data-addon-image') || '',
          blurb: 'Without this there is nothing to hold the tube on your flashlight. Untick it if you already own one.'
        });
      }
    }

    if (config.light && !hasLightSource(items, config)) {
      needed.push({
        kind: 'light',
        blocking: true,
        variantId: config.light.variant_id,
        warranty: config.light.warranty || null,   /* 2026-08-12: see the add handler below */
        title: config.light.title,
        price: config.light.price,
        image: config.light.image,
        blurb: config.light.blurb
      });
    }

    return needed;
  }

  function blockingCount(needed) {
    var count = 0;
    for (var i = 0; i < needed.length; i++) if (needed[i].blocking) count++;
    return count;
  }

  function hasKind(needed, kind) {
    for (var i = 0; i < needed.length; i++) if (needed[i].kind === kind) return true;
    return false;
  }

  function buildModal(missing) {
    var overlay = document.createElement('div');
    overlay.className = 'aoam-gate';
    overlay.setAttribute('data-aoam-gate-modal', '');

    var rows = '';
    for (var i = 0; i < missing.length; i++) {
      var part = missing[i];
      rows +=
        '<label class="aoam-gate__row">' +
        '<input type="checkbox" class="aoam-gate__check" data-gate-index="' + i + '" checked>' +
        (part.image ? '<img class="aoam-gate__thumb" src="' + part.image + '" width="44" height="44" alt="">' : '') +
        '<span class="aoam-gate__body">' +
        '<span class="aoam-gate__top">' +
        '<span class="aoam-gate__name"></span>' +
        '<span class="aoam-gate__price"></span>' +
        '</span>' +
        '<span class="aoam-gate__desc"></span>' +
        '</span>' +
        '</label>';
    }

    // The adapter can now be the only row (a shopper who unticked it with a Critter already in the
    // cart), and "This will not light up on its own" would be a lie there - it lights, it just has
    // nothing to mount the tube with. Match the cart-level guard's wording in that case.
    var lightMissing = hasKind(missing, 'light');
    var title = lightMissing ? 'This will not light up on its own' : 'Your tube needs a connector';
    var sub = lightMissing
      ? 'A tube is a diffuser, not a light. Here is what is still missing from your cart.'
      : 'A tube is a diffuser, not a light of its own. It needs an adapter to twist onto your Critter and hold the tube, and there is not one in your cart.';

    overlay.innerHTML =
      '<div class="aoam-gate__panel" role="dialog" aria-modal="true" aria-labelledby="aoam-gate-title">' +
      // 2026-10-09 (Claude), Joel: "add a grab handle to the add-on prompt too" then "ship it". Shown only under 481px (aoam-addons.css).
      '<span class="aoam-gate__grab" aria-hidden="true"></span>' +
      '<button type="button" class="aoam-gate__close" data-gate-close aria-label="Close">&times;</button>' +
      '<p class="aoam-gate__title" id="aoam-gate-title"></p>' +
      '<p class="aoam-gate__sub"></p>' +
      rows +
      '<button type="button" class="aoam-gate__go" data-gate-add>Add these and continue</button>' +
      '<button type="button" class="aoam-gate__skip" data-gate-skip>No thanks, I already own these</button>' +
      '</div>';

    overlay.querySelector('.aoam-gate__title').textContent = title;
    overlay.querySelector('.aoam-gate__sub').textContent = sub;

    // Titles and blurbs are set as text, never as HTML, so a product name with an apostrophe or an
    // angle bracket cannot break the markup.
    var nameNodes = overlay.querySelectorAll('.aoam-gate__name');
    var priceNodes = overlay.querySelectorAll('.aoam-gate__price');
    var descNodes = overlay.querySelectorAll('.aoam-gate__desc');
    for (var j = 0; j < missing.length; j++) {
      nameNodes[j].textContent = String(missing[j].title || '').replace(/ (\S+)$/, '\u00a0$1');
      priceNodes[j].textContent = missing[j].price;
      descNodes[j].textContent = missing[j].blurb;
    }

    return overlay;
  }

  /* 2026-10-10 audit (busy): "No thanks, I already own these" used to be forgotten. runGate re-reads the cart on every press, so a shopper who owns the
     adapter and light was asked again on the next Add to Cart (the sticky bar included). The answer is now kept for the visit, by KIND of part
     ('addon' = the adapter, 'light' = the Critter), in sessionStorage aoam_gate_owned with an in-memory fallback for private mode. Kind-level is safe
     for the adapter because hasAdapter already accepts the long or the short one. Session scope on purpose, same as the cart guard's aoam_tcg_dismissed.
     Roll back: delete these three helpers and their three call sites (skip handler, add handler, runGate). */
  var OWNED_KEY = 'aoam_gate_owned';
  var ownedMemory = [];
  function ownedKinds() {
    var out = ownedMemory.slice();
    try {
      var list = JSON.parse(sessionStorage.getItem(OWNED_KEY) || '[]');
      if (Array.isArray(list)) for (var i = 0; i < list.length; i++) if (typeof list[i] === 'string' && out.indexOf(list[i]) === -1) out.push(list[i]);
    } catch (error) {}
    return out;
  }
  function rememberOwned(parts) {
    var all = ownedKinds();
    for (var i = 0; i < parts.length; i++) if (parts[i] && parts[i].kind && all.indexOf(parts[i].kind) === -1) all.push(parts[i].kind);
    ownedMemory = all;
    try { sessionStorage.setItem(OWNED_KEY, JSON.stringify(all)); } catch (error) {}
  }
  function withoutOwned(missing) {
    var owned = ownedKinds();
    if (!owned.length) return missing;
    var kept = [];
    for (var i = 0; i < missing.length; i++) if (owned.indexOf(missing[i].kind) === -1) kept.push(missing[i]);
    return kept;
  }

  function runGate(form) {
    var config = gateConfig(form);
    if (!config) return Promise.resolve(true);

    return cartState().then(function (cart) {
      if (cart === null) return true; // could not read the cart, never block the sale
      var missing = neededParts(form, cart, config);
      // 2026-10-10 audit (busy): leave out parts the shopper already answered "I own it" for earlier in this visit. When that is all that stood between
      // this press and the sale, tell the cart-level guard too, so a DIFFERENT tube added later does not stack its connector sheet after a gate they never saw.
      var heldBack = blockingCount(missing);
      missing = withoutOwned(missing);
      if (heldBack && !blockingCount(missing)) {
        try { if (window.AOAM_TUBE_GUARD && window.AOAM_TUBE_GUARD.dismiss) window.AOAM_TUBE_GUARD.dismiss(); } catch (error) {}
      }
      // Interrupt ONLY when something would genuinely be absent from the resulting cart. Everything
      // the tube needs is then listed, including a part that is already ticked and on its way in.
      if (!blockingCount(missing)) return true;

      return new Promise(function (resolve) {
        var overlay = buildModal(missing);
        var lastFocus = document.activeElement;
        document.body.appendChild(overlay);
        document.body.classList.add('aoam-gate-open');

        function close(proceed) {
          document.removeEventListener('keydown', onKey, true);
          overlay.remove();
          document.body.classList.remove('aoam-gate-open');
          if (lastFocus && lastFocus.focus) lastFocus.focus();
          resolve(proceed);
        }

        /* 2026-08-12, Joel: "when clicking out of this pop up window the part that was supposed to be
           added to the cart does not get added". Dismissing an upsell is not cancelling the purchase.
           The shopper had already pressed Add to Cart, and every dismissal path - the backdrop, the X
           and Escape - threw that press away silently, so the tube never reached the cart and nothing
           on screen said why. They now continue exactly like "No thanks": the product is added, along
           with whatever is still ticked on the page.

           Only the dedicated "No thanks, I already own these" button also silences the cart-level
           guard, because that is the one path where the shopper actually said they own one. Clicking
           out says nothing, so if the adapter really is absent the drawer still warns them.
           Roll back by passing false here and in onKey. */
        function onKey(event) {
          if (event.key === 'Escape') close(true);
        }

        // aoam-cart-fix has a document-level click handler that closes the cart drawer on any click
        // landing outside #header_minicart, and this dialog is appended to <body>. Same fix the
        // cart-level guard already carries: stop our own clicks at the overlay. Listeners on the SAME
        // element still run, so the handlers below are unaffected.
        overlay.addEventListener('click', function (event) {
          event.stopPropagation();
        });

        overlay.addEventListener('click', function (event) {
          if (event.target === overlay || event.target.hasAttribute('data-gate-close')) close(true);
        });

        /* 2026-10-09 (Claude), Joel: "drag down to close these quickviews ... and anywhere else". Under 481px this
           dialog is a bottom sheet (aoam-addons.css), so a downward pull from it (scrolled to its top, more vertical
           than sideways) follows the finger; past 90px or a flick it slides off and closes exactly like the X,
           i.e. close(true), the purchase continues. Less springs back. Roll back: delete this block. */
        (function (panel) {
          if (!panel || !window.matchMedia || !window.matchMedia('(max-width: 480px)').matches) return;
          var y0 = null, x0 = 0, t0 = 0, dy = 0, drag = false;
          panel.addEventListener('touchstart', function (e) {
            y0 = null;
            if (e.touches.length !== 1 || panel.scrollTop > 0) return;
            y0 = e.touches[0].clientY; x0 = e.touches[0].clientX; t0 = Date.now(); dy = 0; drag = false;
          }, { passive: true });
          panel.addEventListener('touchmove', function (e) {
            if (y0 == null) return;
            var y = e.touches[0].clientY - y0, x = e.touches[0].clientX - x0;
            if (!drag) {
              if (Math.abs(y) < 6 && Math.abs(x) < 6) return;
              if (y <= 0 || Math.abs(x) > Math.abs(y) || panel.scrollTop > 0) { y0 = null; return; }
              drag = true; panel.style.transition = 'none';
            }
            dy = Math.max(0, y);
            if (e.cancelable) e.preventDefault();
            panel.style.transform = 'translateY(' + dy + 'px)';
            overlay.style.background = 'rgba(0, 0, 0, ' + (0.72 * Math.max(0, 1 - dy / panel.offsetHeight)).toFixed(3) + ')';
          }, { passive: false });
          function end() {
            if (y0 == null || !drag) { y0 = null; return; }
            y0 = null; drag = false;
            var fast = dy > 30 && dy / Math.max(1, Date.now() - t0) > 0.5;
            panel.style.transition = 'transform .22s ease-out';
            if (dy > 90 || fast) { panel.style.transform = 'translateY(100%)'; setTimeout(function () { close(true); }, 220); }
            else { panel.style.transform = 'translateY(0)'; overlay.style.background = ''; setTimeout(function () { panel.style.transition = ''; panel.style.transform = ''; }, 230); }
          }
          panel.addEventListener('touchend', end, { passive: true });
          panel.addEventListener('touchcancel', end, { passive: true });
        })(overlay.querySelector('.aoam-gate__panel'));

        overlay.querySelector('[data-gate-skip]').addEventListener('click', function () {
          rememberOwned(missing); // 2026-10-10 audit (busy): "No thanks" now holds for the rest of the visit
          // 2026-08-11: tell the cart-level guard (assets/aoam-tube-connector-guard.js) that this
          // shopper has already answered "I own these". Without it, the tube lands in the cart a
          // second later, the drawer opens, and the guard stacks a second modal saying the same
          // thing. Guarded so the PDP gate still works with the guard absent. Delete this block to
          // roll back.
          try {
            if (window.AOAM_TUBE_GUARD && window.AOAM_TUBE_GUARD.dismiss) window.AOAM_TUBE_GUARD.dismiss();
          } catch (error) {}
          close(true);
        });

        overlay.querySelector('[data-gate-add]').addEventListener('click', function () {
          var extras = [];
          var declined = false;
          var unwanted = []; // 2026-10-10 audit (busy): rows left unticked here say "I own it", remembered below

          var checks = overlay.querySelectorAll('[data-gate-index]');
          for (var i = 0; i < checks.length; i++) {
            var part = missing[parseInt(checks[i].getAttribute('data-gate-index'), 10)];
            var wanted = checks[i].checked;
            if (!wanted) unwanted.push(part);

            if (part.kind === 'addon') {
              // Mirror the dialog BOTH ways onto the real checkbox on the page. The existing add-on
              // flow below then adds it, so there is one code path that talks to /cart/add.js for
              // companion parts. 2026-08-12: it only ever ticked, so a shopper who unticked the
              // adapter HERE still had it added a moment later - the one control in this dialog that
              // did nothing at all. Unticking now genuinely declines it.
              var box = part.row.querySelector('[data-aoam-addon]');
              if (box && box.checked !== wanted) { box.checked = wanted; announce([box]); }
              // 2026-10-09 (Claude): add-on cards have no checkbox any more (their + adds straight to the cart), so the gate adds the part itself.
              else if (!box && wanted) { var gvs = part.row.querySelector('[data-aoam-addon-variant]'), gvb = part.row.querySelector('[data-variant-id]'); var gvid = parseInt(gvs ? gvs.value : (gvb && gvb.getAttribute('data-variant-id')), 10); if (gvid) extras.push({ id: gvid, quantity: 1 }); }
              if (!wanted) declined = true;
            } else if (wanted && part.variantId) {
              // 2026-08-12 (Claude), Joel approved. Carry the light's warranty properties onto the
              // line. Without them the cart cannot tell this product is warranty-eligible, so the
              // Lifetime Warranty was silently never offered on anything bought through this gate -
              // while the identical product bought from its own PDP was offered it. The four names
              // are exactly the ones snippets/product-form.liquid emits and aoam-cart-fix keys on.
              // The site-wide opt-out still applies: this only marks the line eligible, it never
              // adds a warranty line itself. TO ROLL BACK: restore the single-line push and revert
              // the "warranty" key in snippets/aoam-addons.liquid.
              var gateLine = { id: part.variantId, quantity: 1 };
              if (part.warranty && part.warranty._warranty_pro_id) gateLine.properties = part.warranty;
              extras.push(gateLine);
            }
          }

          // Unticking the required adapter here says the same thing as "I already own these", so it
          // silences the cart-level guard rather than stacking a second modal in the drawer a second
          // later saying exactly what this one just said.
          if (declined) {
            try {
              if (window.AOAM_TUBE_GUARD && window.AOAM_TUBE_GUARD.dismiss) window.AOAM_TUBE_GUARD.dismiss();
            } catch (error) {}
          }

          rememberOwned(unwanted); // 2026-10-10 audit (busy): not asked about these again this visit
          if (!extras.length) return close(true);

          var goButton = this;
          goButton.classList.add('btn--loading');

          fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: extras })
          })
            .catch(function (error) {
              console.error('[aoam-addons] gate could not add the flashlight', error);
            })
            .then(function () {
              goButton.classList.remove('btn--loading');
              close(true);
            });
        });

        document.addEventListener('keydown', onKey, true);
        overlay.querySelector('[data-gate-add]').focus();
      });
    });
  }

  /* ---------------------------------------------------------------------------------------------
     2026-07-29, Joel: "if i change a variant in this upsell section, the variant should show. right
     now the black silicone saber cap shows but the clear one is selected". The row thumb was the product's
     featured image and never moved. Swap it to the chosen option's data-variant-image (set in
     snippets/aoam-addons.liquid), falling back to data-default-src for a variant with no image of
     its own. Delegated on document so it also covers a form rendered later (quick view).
     Delete this block to roll back.
     --------------------------------------------------------------------------------------------- */

  function swapAddonThumb(select) {
    var row = select.closest ? select.closest('[data-aoam-addon-row]') : null;
    if (!row) return;

    var thumb = row.querySelector('[data-aoam-addon-thumb]');
    var option = select.options[select.selectedIndex];
    if (!thumb || !option) return;

    var src = option.getAttribute('data-variant-image') || thumb.getAttribute('data-default-src') || '';
    if (src && thumb.getAttribute('src') !== src) {
      thumb.setAttribute('src', src);
      thumb.removeAttribute('srcset');
    }

    // Keep the checkbox's own variant id honest. tickedItems() prefers the select, but the id is
    // also the fallback if the select is ever removed, and it reads as the row's current choice.
    var checkbox = row.querySelector('[data-aoam-addon]');
    if (checkbox && select.value) checkbox.setAttribute('data-variant-id', select.value);
  }

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (select && select.matches && select.matches('[data-aoam-addon-variant]')) swapAddonThumb(select);
  });

  function tickedItems(form) {
    var items = [];
    var rows = form.querySelectorAll('[data-aoam-addon-row]');

    for (var i = 0; i < rows.length; i++) {
      var checkbox = rows[i].querySelector('[data-aoam-addon]');
      if (!checkbox || !checkbox.checked) continue;

      var select = rows[i].querySelector('[data-aoam-addon-variant]');
      var id = parseInt(select ? select.value : checkbox.getAttribute('data-variant-id'), 10);
      if (id) items.push({ id: id, quantity: 1 });
    }

    return items;
  }

  function showError(form, message) {
    var box = form.querySelector('[data-aoam-addons-error]');
    if (!box) return;
    box.textContent = message;
    box.classList.remove('hide');
  }

  function clearError(form) {
    var box = form.querySelector('[data-aoam-addons-error]');
    if (!box) return;
    box.textContent = '';
    box.classList.add('hide');
  }

  function resubmit(form, button) {
    if (button) button.classList.remove('btn--loading');
    form.setAttribute(DONE_ATTR, '1');
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  /* ---------------------------------------------------------------------------------------------
     2026-08-12, found while checking Joel's report on mobile. THE MOBILE STICKY BAR DROPPED EVERY
     TICKED PART. `.sticky-add-to-cart-btn button` (snippets/sticky-cart-btn-pdp.liquid) sits far
     outside `form.product-single__form`, so it never fires a form submit. Above 1081px the sticky
     script takes the click over and clicks the real Add to Cart button, which lands in the submit
     handler below and everything works. BELOW 1081px it deliberately lets theme.js handle it, and
     that handler POSTs `{id, quantity: 1}` straight to /cart/add.js - it reads the warranty
     properties off the form and nothing else. So a phone shopper who scrolled past the module with
     the adapter ticked, then tapped the sticky bar, got the bare tube: the ticked parts were dropped
     silently and the gate never ran, because there was no submit to intercept.

     Fixed by ADDING the ticked parts after the theme's add rather than intercepting the click.
     Intercepting is what the desktop branch does, but here it would have to stop the event at
     document level, which also kills the drawer-open in aoam-cart-fix.liquid that rides the same
     click. Gated on the theme's own 1081px breakpoint so it can never double-add on the desktop
     path, and the cart-level guard is asked to re-check afterwards, so a shopper who unticked the
     adapter still gets the drawer warning.

     IT MUST WAIT FOR THE THEME'S POST TO FINISH. Measured on the live store 2026-08-12: firing both
     at once returned 200 for BOTH and left only ONE of them in the cart - the tube was gone and the
     adapter survived. Shopify's cart add is read-modify-write, so two POSTs in the same instant can
     lose one, and both still answer 200, which makes it invisible unless you read the cart back.
     So this waits for the theme's own `ajaxProduct:added`, with a timeout in case the theme's add
     fails and never fires it. Never make these concurrent again. Delete this block to roll back.
     --------------------------------------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest('.sticky-add-to-cart-btn button');
    if (!button || button.disabled || button.classList.contains('disabled')) return;
    /* AOAM (2026-09-21, Claude): DISABLED, deliberately kept rather than deleted. This block only
       existed because the sticky button below 1081px never produced a form submit, so the capture
       phase submit handler further down could not add the ticked parts. sticky-cart-btn-pdp.liquid
       now routes EVERY width through the real Add to Cart button, so that submit handler runs on
       phones too and this path would add the ticked parts a second time. Roll back by restoring the
       1081 gate on the line below. The concurrency warning above still stands. */
    return;
    // eslint-disable-next-line no-unreachable
    if (window.innerWidth >= 1081) return; // desktop routes through the real Add to Cart button

    var form = document.querySelector('form.product-single__form');
    if (!form || !form.querySelector('[data-aoam-addon]')) return; // not a tube PDP, leave it alone

    var items = tickedItems(form);
    if (!items.length) return;

    // Untick now, not on success. The theme's add and this one are separate requests, so a second
    // tap before the drawer repaints would otherwise add the same parts twice.
    var checkboxes = form.querySelectorAll('[data-aoam-addon]');
    var unticked = [];
    for (var i = 0; i < checkboxes.length; i++) if (checkboxes[i].checked) { checkboxes[i].checked = false; unticked.push(checkboxes[i]); }
    announce(unticked);

    var sent = false;
    var timer = null;

    function restore() {
      for (var j = 0; j < checkboxes.length; j++) {
        var row = checkboxes[j].closest('[data-aoam-addon-row]');
        var select = row && row.querySelector('[data-aoam-addon-variant]');
        var id = parseInt((select && select.value) || checkboxes[j].getAttribute('data-variant-id'), 10);
        for (var k = 0; k < items.length; k++) if (id === items[k].id && !checkboxes[j].checked) { checkboxes[j].checked = true; announce([checkboxes[j]]); }
      }
    }

    function onAdded() {
      // A short settle after the theme's event keeps the two writes genuinely sequential rather than
      // merely ordered.
      setTimeout(addTheParts, 250);
    }

    function addTheParts() {
      if (sent) return;
      sent = true;
      clearTimeout(timer);
      document.removeEventListener('ajaxProduct:added', onAdded);

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart/add ' + response.status);
          // Same events the theme fires for its own add, so the drawer repaints with the new lines.
          try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (error) {}
          try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: {} })); } catch (error) {}
          try { if (window.AOAM_TUBE_GUARD && window.AOAM_TUBE_GUARD.check) window.AOAM_TUBE_GUARD.check(); } catch (error) {}
        })
        .catch(function (error) {
          console.error('[aoam-addons] sticky add-on request failed', error);
          // Put them back so the shopper can try again rather than silently losing the choice.
          restore();
          showError(form, 'We could not add the extra parts. Your main item was still added.');
        });
    }

    // The theme fires this once its own /cart/add.js resolves.
    document.addEventListener('ajaxProduct:added', onAdded);
    // Fallback: if the theme's add fails outright the event never comes, and the shopper should still
    // get what they ticked rather than silently nothing.
    timer = setTimeout(addTheParts, 6000);
  });

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || typeof form.querySelector !== 'function') return;
      // 2026-10-09 (Claude): cards carry no checkbox now (their + adds straight to the cart), so look for the rows, or the tube gate never runs.
      if (!form.querySelector('[data-aoam-addon], [data-aoam-addon-row]')) return;

      // This is the submit we re-dispatched ourselves. Let the theme handle it.
      if (form.hasAttribute(DONE_ATTR)) {
        form.removeAttribute(DONE_ATTR);
        return;
      }

      // First pass: run the compatibility gate. It resolves immediately and invisibly when the cart
      // is already complete, so the common case costs one /cart.js read and nothing else.
      if (!form.hasAttribute(GATE_ATTR)) {
        event.preventDefault();
        event.stopPropagation();

        var gateButton = form.querySelector('[data-add-to-cart]');
        if (gateButton) gateButton.classList.add('btn--loading');

        runGate(form).then(function (proceed) {
          if (gateButton) gateButton.classList.remove('btn--loading');
          if (!proceed) return; // buyer closed the dialog, add nothing at all
          form.setAttribute(GATE_ATTR, '1');
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        });
        return;
      }
      form.removeAttribute(GATE_ATTR);

      var items = tickedItems(form);
      if (!items.length) return;

      event.preventDefault();
      event.stopPropagation();
      clearError(form);

      var button = form.querySelector('[data-add-to-cart]');
      if (button) button.classList.add('btn--loading');

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response
            .json()
            .catch(function () {
              return {};
            })
            .then(function (data) {
              return { ok: response.ok, data: data };
            });
        })
        .then(function (result) {
          if (result.ok) {
            // Added, so untick them. A second Add to Cart click should not duplicate the parts.
            var checkboxes = form.querySelectorAll('[data-aoam-addon]');
            var unticked = [];
            for (var i = 0; i < checkboxes.length; i++) if (checkboxes[i].checked) { checkboxes[i].checked = false; unticked.push(checkboxes[i]); }
            announce(unticked);
          } else {
            showError(
              form,
              (result.data && result.data.description) ||
                'We could not add one of the extra parts. Your main item was still added.'
            );
          }
        })
        .catch(function (error) {
          console.error('[aoam-addons] add-on request failed', error);
          showError(form, 'We could not add the extra parts. Your main item was still added.');
        })
        .then(function () {
          // Always hand back to the theme so the main product is added either way.
          resubmit(form, button);
        });
    },
    true
  );
})();
